import { render } from "./CompanyLeadsView.vue?vue&type=template&id=78e21140&scoped=true"
import script from "./CompanyLeadsView.vue?vue&type=script&lang=js"
export * from "./CompanyLeadsView.vue?vue&type=script&lang=js"

import "./CompanyLeadsView.vue?vue&type=style&index=0&id=78e21140&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78e21140"]])

export default __exports__